<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="align-items-center d-flex xrx-time-select">
  <div class="dropdowns align-items-center d-flex">
    <xrx-select
      class="xrx-hour"
      [list]="hours"
      [placement]="placement"
      localize="value"
      property="key"
      [(selectedItem)]="selectedHour"
      (change)="_time.hour = $event.value; onChange()">
    </xrx-select>
    <span class="colon">:</span>
    <xrx-select
      class="xrx-minute"
      [list]="minutes"
      [placement]="placement"
      localize="value"
      property="key"
      [(selectedItem)]="selectedMinute"
      (change)="_time.minute = $event.value; onChange()">
    </xrx-select>
  </div>
  <div
    class="xrx-seg-control am-pm"
    role="tablist"
    aria-label="Select AM or PM">
    <button
      type="button"
      class="xrx-btn btn-secondary"
      [ngClass]="{ checked: _time.ampm == 'am' }"
      (click)="_time.ampm = 'am'; onChange()">
      <span class="btn-label" [xdaTranslate]="'SDE_AM'"></span>
    </button>
    <button
      type="button"
      class="xrx-btn btn-secondary"
      [ngClass]="{ checked: _time.ampm == 'pm' }"
      (click)="_time.ampm = 'pm'; onChange()">
      <span class="btn-label" [xdaTranslate]="'SDE_PM'"></span>
    </button>
  </div>
</div>
